import { getServerParam } from '@constants'

export default {
  namespaced: true,

  state: {
    isOpen: false,
    termType: 2, //1: 投票期間中, 2: 投票終了, 3:結果発表
    currentDay: 99,
  },

  getters: {
    isOpen(state) {
      return state.isOpen
    },
    termType(state) {
      return state.termType
    },
    currentDay(state) {
      return state.currentDay
    },
  },

  mutations: {
    setMenuState(state, bool){
      state.isOpen = bool
    },
    setTermType(state, status){
      //status: 'open' OR 'aggregate' OR 'result'
      let termType = 2
      switch (status) {
        case 'open':
          termType = 1
          break
        case 'aggregate':
          termType = 2
          break
        case 'result':
          termType = 3
          break
      }
      state.termType = termType
    },
    setCurrentDay(state, currentDay) {
      state.currentDay = currentDay
    },
  },

  actions: {
    init({ commit }) {
      let config = getServerParam()

      if (config.campaignStatus) {
        commit('setTermType', config.campaignStatus)
      }

      if (config.currentDay) {
        commit('setCurrentDay', Number(config.currentDay))
      }

    }
  },
}